import { birdzReactLibrary } from '@applications-terrains/birdz-react-library';
import { SupportAuthService } from '../components/Auth/SupportAuthService';

let authServiceInstance = birdzReactLibrary.authService;

if (!authServiceInstance) {
  const auth = new SupportAuthService();
  birdzReactLibrary.authService = auth;
  authServiceInstance = auth;
}

export const authService = authServiceInstance;
